import React from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import * as R from 'ramda';
import ProductGradeChip from './component/ProductGradeChip';

const minWidth = 150;

const AcceptedColumns = ({ handleCopyNomination, isProductShippingViewOnly }) => {
  return [
    {
      field: 'segmentName',
      flex: 1,
      headerName: 'Segment',
      minWidth,
    },
    {
      field: 'shipperName',
      flex: 1,
      headerName: 'Shipper',
      minWidth,
    },
    {
      aggregable: false,
      field: 'productName',
      flex: 1,
      headerName: 'Product Grade',
      minWidth,
      renderCell: ({ value }) => <ProductGradeChip value={value} />,
    },
    {
      align: 'left',
      field: 'volNominated',
      flex: 1,
      headerAlign: 'left',
      headerName: 'Vol. Nominated (bbl)',
      minWidth,
      type: 'number',
    },
    {
      align: 'left',
      field: 'volAwarded',
      flex: 1,
      headerAlign: 'left',
      headerName: 'Vol. Awarded (bbl)',
      minWidth,
      type: 'number',
    },
    {
      aggregable: true,
      align: 'left',
      field: 'volAccepted',
      flex: 1,
      headerAlign: 'left',
      headerName: 'Vol. Accepted (bbl)',
      minWidth,
      type: 'number',
    },
    {
      field: 'nomMonth',
      flex: 1,
      headerName: 'Nomination Month',
      minWidth,
    },
    {
      disableExport: true,
      field: 'action',
      getActions: params => {
        const { row } = params;
        const { nominationId } = row;

        if (isProductShippingViewOnly || R.isNil(nominationId)) return [];

        return [
          <GridActionsCellItem
            icon={<FileCopyIcon />}
            label="Copy"
            onClick={() => handleCopyNomination(nominationId)}
          />,
        ];
      },
      headerName: 'Copy',
      minWidth,
      type: 'actions',
    },
  ];
};

export default AcceptedColumns;
